"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConversationMetaModel = void 0;
const ViewFieldKey_1 = __importDefault(require("@opsbase/lib-data-viewfield/ViewFieldKey"));
const lib_i18n_1 = __importDefault(require("@opsbase/lib-i18n"));
const MetaModel_1 = __importDefault(require("../MetaModel"));
exports.ConversationMetaModel = new MetaModel_1.default({
    name: () => lib_i18n_1.default.t('conversations'),
    queryName: 'conversations',
    filterables: [],
    groupables: [],
    fields: [ViewFieldKey_1.default.ID, ViewFieldKey_1.default.TITLE, ViewFieldKey_1.default.UPDATEDDATE],
});
exports.default = exports.ConversationMetaModel;
